/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EVENTSLIST } from './eVENTSLIST';


export interface REPORTCONFIGURATION {
    /**
     * Report configuration name Shall contain only letters, numbers, whitespaces, dashes and underscores
     */
    name: string;
    /**
     * Type of the report
     */
    type: REPORTCONFIGURATION.TypeEnum;
    /**
     * Folder that will be used to store this type of reports Shall contain only letters, numbers, whitespaces, dashes and underscores if it's just folder name also forward slashes or backslashes if it is a relative path
     */
    folder?: string;
    eventsList?: EVENTSLIST;
    /**
     * The list of item IDs to be reported. Meaning depends on the type   EID for eUICC reports   Card group ID for Card Group Reports   Empty list means - all items of the available type to be included. 
     */
    itemsList?: Array<string>;
}
export namespace REPORTCONFIGURATION {
    export type TypeEnum = 'CARD' | 'CARD_GROUP';
    export const TypeEnum = {
        CARD: 'CARD' as TypeEnum,
        CARDGROUP: 'CARD_GROUP' as TypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/rEPORTCONFIGURATION.ts